export {
  useAnalytics,
  AnalyticsProvider,
  AnalyticsConsumer,
  withAnalytics,
} from "use-analytics";

export * from "./client";
export * from "./plugins";
export * from "./dom-tracking";
export * from "./events";
export * from "./feature-flags";

export type { AnalyticsInstance } from "analytics";
